// @ts-nocheck

import localStorageHelper from '@/helpers/global/localStorage.helper';

window.dataLayer = window.dataLayer || [];
window.gtag = function () {
  window.dataLayer.push(arguments);
};

const CONSENT_KEY = 'consentMode';

interface ConsentOptions {
  necessary: boolean;
  analytics: boolean;
  preferences: boolean;
  marketing: boolean;
}

interface ConsentMode {
  functionality_storage: 'granted' | 'denied';
  security_storage: 'granted' | 'denied';
  ad_storage: 'granted' | 'denied';
  analytics_storage: 'granted' | 'denied';
  personalization_storage: 'granted' | 'denied';
}

class ConsentModeHelper {
  private closeConsent(): void {
    document.querySelector('#cookie-consent-banner')?.classList.remove('!translate-y-0');
  }

  private setConsent(consent: ConsentOptions): void {
    const consentMode: ConsentMode = {
      functionality_storage: consent.necessary ? 'granted' : 'denied',
      security_storage: consent.necessary ? 'granted' : 'denied',
      ad_storage: consent.marketing ? 'granted' : 'denied',
      analytics_storage: consent.analytics ? 'granted' : 'denied',
      personalization_storage: consent.preferences ? 'granted' : 'denied',
    };

    window.gtag?.('consent', 'update', consentMode);
    localStorageHelper.setItem(CONSENT_KEY, JSON.stringify(consentMode));

    try {
      if (consentMode.ad_storage === 'granted' && consentMode.analytics_storage === 'granted') {
        if (typeof window.clarity === 'function') {
          window.clarity('consent');
        }
      }
    } catch (e) {
      console.error('Error updating clarity consent:', e);
    }
  }

  private acceptAll(): void {
    this.setConsent({ necessary: true, analytics: true, preferences: true, marketing: true });
  }

  initDataLayer(): void {
    const stored = localStorageHelper.getItem(CONSENT_KEY);

    if (stored === null) {
      window.gtag?.('consent', 'default', {
        ad_storage: 'granted',
        analytics_storage: 'granted',
        personalization_storage: 'granted',
        functionality_storage: 'granted',
        security_storage: 'granted',
      });
      return;
    }

    try {
      const consentMode: ConsentMode = JSON.parse(stored);
      window.gtag?.('consent', 'default', consentMode);

      if (consentMode.ad_storage === 'granted' && consentMode.analytics_storage === 'granted') {
        if (typeof window.clarity === 'function') {
          window.clarity('consent');
        }
      }
    } catch (e) {
      console.error('Error parsing consent mode:', e);
    }
  }

  init(): void {
    if (localStorageHelper.getItem(CONSENT_KEY) !== null) return;

    document.querySelectorAll('.accept-all-cookies-button').forEach((button) => {
      button.addEventListener('click', () => {
        this.acceptAll();
        this.closeConsent();
      });
    });

    document.querySelector('.accept-some-cookies-button')?.addEventListener('click', () => {
      this.setConsent({
        necessary: true,
        analytics: (document.querySelector('#consent-analytics') as HTMLInputElement)?.checked,
        preferences: (document.querySelector('#consent-preferences') as HTMLInputElement)?.checked,
        marketing: (document.querySelector('#consent-marketing') as HTMLInputElement)?.checked,
      });
      window.location.reload();
    });

    document.querySelector('.reject-all-cookies-button')?.addEventListener('click', () => {
      this.setConsent({ necessary: false, analytics: false, preferences: false, marketing: false });
      window.location.reload();
    });

    document.querySelector('.cookie-consent-settings-button')?.addEventListener('click', () => {
      const inner = document.querySelector('.cookie-consent-banner-settings-inner') as HTMLElement;
      const settings = document.querySelector('.cookie-consent-settings') as HTMLElement;
      if (inner && settings) {
        settings.style.height = `${inner.offsetHeight}px`;
      }
    });

    setTimeout(() => {
      document.querySelector('#cookie-consent-banner')?.classList.add('!translate-y-0', '!opacity-100');
      this.acceptAll();
    }, 300);
  }
}

export default new ConsentModeHelper();
